import { render, staticRenderFns } from "./quantitative-rule-statistics.vue?vue&type=template&id=6fff69ce&scoped=true&"
import script from "./quantitative-rule-statistics.vue?vue&type=script&lang=ts&"
export * from "./quantitative-rule-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./quantitative-rule-statistics.vue?vue&type=style&index=0&id=6fff69ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff69ce",
  null
  
)

export default component.exports